// Site-wide statistics
// Update these values monthly. Every page, meta description and schema reads from this single file.

export const SITE_STATS = {
  activeClients: 349,
  jobsCompletedThisYear: 2055,
  yearsExperience: 20  // This is also calculated dynamically from 2006 in some places
};

// Formatted versions for display
export const FORMATTED_STATS = {
  activeClients: '349',
  jobsCompletedThisYear: '2,055',
  yearsExperience: '20+'
};
